import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-buy-sell-reviewers-list',
  templateUrl: './buy-sell-reviewers-list.component.html',
  styleUrls: ['./buy-sell-reviewers-list.component.scss']
})
export class BuySellReviewersListComponent implements OnInit {
  @Input() buySellPlanApprovals: any[];
  
  constructor() { }

  ngOnInit(): void {
  }

  getStatusChipClass(statusId): string {
    const classMap = {
      'DENIED': 'red-chip',
      'APPROVED': 'green-chip',
      'Complete': 'green-chip',
      'PENDING': 'orange-chip',
      'PENDING_APPROVAL': 'orange-chip',
      'AVAILABLE': 'blue-chip'
    };
    return classMap[statusId] || '';
  }

}
